module.exports = __webpack_public_path__ + "media/images/services/thumbnail/ceremony-100x100-2257c4e2ac0fedf4b626251da66e0b3a.jpg";